<template>
  <div class="p-3 max-h-80vh overflow-y-auto">
    <base-radio v-for="{id, name, icon} in sortedOptions"
               :key="id"
               :id="id"
               :value="id"
               class="text-gray-dark p-2"
               v-model="selectedValue"
    >
      <div class="flex gap-2">
        <div v-if="icon"><component :is="icon" /></div>
        <div class="text-base">{{name}}</div>
      </div>
    </base-radio>
  </div>
</template>

<script>
import BaseRadio from '@/components/base-components/BaseRadio'
import ContactIcon from '@/assets/images/icons/ContactIcon'
import RequestIcon from '@/assets/images/icons/RequestIcon'
import sort from 'ramda/src/sort'

export default {
  name: 'RadioDropdown',
  components: {
    BaseRadio,
    ContactIcon,
    RequestIcon
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    selectedValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('change', value)
      }
    },

    sortedOptions() {
      const sorter = (a, b) => a.name.localeCompare(b.name)
      return sort(sorter, this.options)
    }
  }
}
</script>

<style scoped>

</style>
